/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateEventPaymentDto } from '../model';
// @ts-ignore
import type { CreateEventPaymentResponseDto } from '../model';
// @ts-ignore
import type { PaginatedPaymentsResponseDto } from '../model';
// @ts-ignore
import type { PaymentWebhookDto } from '../model';
// @ts-ignore
import type { PaymentWebhookResponseDto } from '../model';
/**
 * PaymentsApi - axios parameter creator
 * @export
 */
export const PaymentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new payment to register for an event
         * @param {CreateEventPaymentDto} createEventPaymentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerCreateEventPayment: async (createEventPaymentDto: CreateEventPaymentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEventPaymentDto' is not null or undefined
            assertParamExists('paymentsControllerCreateEventPayment', 'createEventPaymentDto', createEventPaymentDto)
            const localVarPath = `/api/payments/event-payment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEventPaymentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user\'s payments with pagination
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerFindAllPaginated: async (page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/payments/paginated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Process payment webhook from external payment providers
         * @param {string} xApiSignature Webhook signature for verification
         * @param {PaymentWebhookDto} paymentWebhookDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerProcessPaymentWebhook: async (xApiSignature: string, paymentWebhookDto: PaymentWebhookDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xApiSignature' is not null or undefined
            assertParamExists('paymentsControllerProcessPaymentWebhook', 'xApiSignature', xApiSignature)
            // verify required parameter 'paymentWebhookDto' is not null or undefined
            assertParamExists('paymentsControllerProcessPaymentWebhook', 'paymentWebhookDto', paymentWebhookDto)
            const localVarPath = `/api/payments/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xApiSignature != null) {
                localVarHeaderParameter['x-api-signature'] = String(xApiSignature);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentWebhookDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentsApi - functional programming interface
 * @export
 */
export const PaymentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new payment to register for an event
         * @param {CreateEventPaymentDto} createEventPaymentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsControllerCreateEventPayment(createEventPaymentDto: CreateEventPaymentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateEventPaymentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsControllerCreateEventPayment(createEventPaymentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsControllerCreateEventPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get user\'s payments with pagination
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsControllerFindAllPaginated(page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedPaymentsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsControllerFindAllPaginated(page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsControllerFindAllPaginated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Process payment webhook from external payment providers
         * @param {string} xApiSignature Webhook signature for verification
         * @param {PaymentWebhookDto} paymentWebhookDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsControllerProcessPaymentWebhook(xApiSignature: string, paymentWebhookDto: PaymentWebhookDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentWebhookResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsControllerProcessPaymentWebhook(xApiSignature, paymentWebhookDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsControllerProcessPaymentWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentsApi - factory interface
 * @export
 */
export const PaymentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new payment to register for an event
         * @param {CreateEventPaymentDto} createEventPaymentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerCreateEventPayment(createEventPaymentDto: CreateEventPaymentDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateEventPaymentResponseDto> {
            return localVarFp.paymentsControllerCreateEventPayment(createEventPaymentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user\'s payments with pagination
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerFindAllPaginated(page?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedPaymentsResponseDto> {
            return localVarFp.paymentsControllerFindAllPaginated(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Process payment webhook from external payment providers
         * @param {string} xApiSignature Webhook signature for verification
         * @param {PaymentWebhookDto} paymentWebhookDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerProcessPaymentWebhook(xApiSignature: string, paymentWebhookDto: PaymentWebhookDto, options?: RawAxiosRequestConfig): AxiosPromise<PaymentWebhookResponseDto> {
            return localVarFp.paymentsControllerProcessPaymentWebhook(xApiSignature, paymentWebhookDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentsApi - object-oriented interface
 * @export
 * @class PaymentsApi
 * @extends {BaseAPI}
 */
export class PaymentsApi extends BaseAPI {
    /**
     * 
     * @summary Create a new payment to register for an event
     * @param {CreateEventPaymentDto} createEventPaymentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsControllerCreateEventPayment(createEventPaymentDto: CreateEventPaymentDto, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsControllerCreateEventPayment(createEventPaymentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user\'s payments with pagination
     * @param {number} [page] Page number (default: 1)
     * @param {number} [limit] Number of items per page (default: 10, max: 100)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsControllerFindAllPaginated(page?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsControllerFindAllPaginated(page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Process payment webhook from external payment providers
     * @param {string} xApiSignature Webhook signature for verification
     * @param {PaymentWebhookDto} paymentWebhookDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsControllerProcessPaymentWebhook(xApiSignature: string, paymentWebhookDto: PaymentWebhookDto, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsControllerProcessPaymentWebhook(xApiSignature, paymentWebhookDto, options).then((request) => request(this.axios, this.basePath));
    }
}

